<template>
    <div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogInfoOuvrier" :persistent="true"  fullscreen transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">

                    <v-toolbar-title >FICHE OUVRIER {{infoOuvrier.nom}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-layout row class="mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-5">
                        <v-flex xs1  class="text-xs-left mr-5 ">
                            <v-avatar :tile="true" size="140px" height="140px" color="grey lighten-4"> <img :src="infoOuvrier.url"  alt="avatar">
                            </v-avatar>
                        </v-flex>

                        <!--Information personnelles-->
                        <v-flex xs7 class="mr-2 ml-2">

                            <v-layout wrap>
                                <v-flex xs12>
                                    <h4 mt-2>INFORMATION PERSONNELLE</h4>
                                    <v-divider class="mb-3"></v-divider>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout row>
                                        <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-layout row>
                                                        <v-flex xs4>Matricule</v-flex>
                                                        <v-flex xs8 class="text-xs-right title">
                                                            {{infoOuvrier.matricule}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>
                                                    <v-layout row>
                                                        <v-flex xs6>Nom</v-flex>
                                                        <v-flex xs6 class="text-xs-right title">
                                                            {{infoOuvrier.nom}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>

                                                    <v-layout row>
                                                        <v-flex xs6>Domicile/Siege</v-flex>
                                                        <v-flex xs6 class="text-xs-right title">
                                                            {{infoOuvrier.domicile}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>

                                                    <v-layout row>
                                                        <v-flex xs6>Contact</v-flex>
                                                        <v-flex xs6 class="text-xs-right title">
                                                            {{infoOuvrier.contact}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>

                                                    <v-layout row>
                                                        <v-flex xs6>Profession</v-flex>
                                                        <v-flex xs6 class="text-xs-right title">
                                                            {{infoOuvrier.profession}}
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider class="mb-3"></v-divider>
                                                </v-flex>
                                            </v-layout>


                                        </v-flex>

                                        <v-flex xs6> <!--COLONNE 2-->
                                            <v-layout row>
                                                <v-flex xs6>Type pièce</v-flex>
                                                <v-flex xs6 class="text-xs-right title">
                                                    {{infoOuvrier.piece}}
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs6>Numéro ID</v-flex>
                                                <v-flex xs6 class="text-xs-right title">
                                                    {{infoOuvrier.numPiece}}
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs6>Date de naissance</v-flex>
                                                <v-flex xs6 class="text-xs-right title">
                                                    {{infoOuvrier.dateNaiss}}
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                            <v-layout row>
                                                <v-flex xs4>Enregistré le</v-flex>
                                                <v-flex xs8 class="text-xs-right title">
                                                    {{infoOuvrier.created}}
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mb-3"></v-divider>

                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                        </v-flex>
                        <!--Information personnelles-->

                        <!-- <v-container  style="left:150px" > -->
                            <v-layout row class="mt-3">
                                <v-flex md3>
                                    <div id="statMontVerse" style="width: 400px; height: 300px"></div>
                                </v-flex>
                            </v-layout>
                        <!-- </v-container> -->

                    </v-layout>

                    <v-layout row class="mt-4">
                        <v-flex sm12 >
                            <el-tabs v-model="onglet" type="border-card" @tab-click="handleTabClick(onglet)" >
                                <el-tab-pane label="Contrats" >
                                    <v-layout row  class="mb-4">
                                        <v-flex xs12 style="width:100%;"  >
                                            <h4 mt-2>LISTE DES CONTRATS</h4>
                                            <v-divider class="mb-2"></v-divider>
                                            <v-layout row >

                                                <v-flex class="mb-1" xs12 md4 >
                                                    <v-card-text class="text-xs-center">
                                                        <v-chip
                                                                label
                                                                outline
                                                                color="primary darken-1"
                                                                class="elevation-4"
                                                                style="width:100%"
                                                        >
                                                            <span class="subheading">Total : </span>
                                                            <span class="title">&nbsp  {{ new Intl.NumberFormat().format(montantTotal)}} </span>
                                                        </v-chip>
                                                    </v-card-text>
                                                </v-flex>


                                                <v-flex class="mb-1" xs12 md4 >
                                                    <v-card-text class="text-xs-center">
                                                        <v-chip
                                                                label
                                                                outline
                                                                color="green darken-1"
                                                                class="elevation-4"
                                                                style="width:100%"
                                                        >
                                                            <span class="subheading">Total payé: </span>
                                                            <span class="title">&nbsp  {{ new Intl.NumberFormat().format(montantTotalVerse) }} </span>
                                                        </v-chip>
                                                    </v-card-text>
                                                </v-flex>

                                                <v-flex class="mb-1" xs12 md4 >
                                                    <v-card-text class="text-xs-center">
                                                        <v-chip
                                                                label
                                                                outline
                                                                color="orange darken-1"
                                                                class="elevation-4"
                                                                style="width:100%"
                                                        >
                                                            <span class="subheading">Total restant: </span>
                                                            <span class="title">&nbsp  {{ new Intl.NumberFormat().format(montantTotalRestant)}} </span>
                                                        </v-chip>
                                                    </v-card-text>
                                                </v-flex>


                                            </v-layout>
                                            <v-layout row wrap>
                                                <!--LISTE CONTRAT OUVRIER-->
                                                <v-flex xs12 class="elevation-3 pt-3 pl-3 pr-3 pb-3">
                                                    <h4 >PRESTATION TACHES </h4>
                                                    <v-divider class="mb-2"></v-divider>
                                                    <data-tables :data="listeContratsTache" style="width:99%;">
                                                        <el-table-column prop="idContrat" label="ID-CONTRAT" align="center" ></el-table-column>
                                                        <el-table-column prop="etatContrat" label="ETAT CONTRAT" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag v-if="scope.row.etat == 0" class="subheading" type="info">
                                                                    {{ scope.row.etatContrat}}
                                                                </el-tag>
                                                                <el-tag v-if="scope.row.etat == 1" class="subheading">
                                                                    {{ scope.row.etatContrat}}
                                                                </el-tag>
                                                                <el-tag v-if="scope.row.etat == 2" class="subheading" type="blue">
                                                                    {{ scope.row.etatContrat}}
                                                                </el-tag>
                                                                <el-tag v-if="scope.row.etat == 3" class="subheading" type="success">
                                                                    {{ scope.row.etatContrat}}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <!-- <el-table-column prop="tache" label="TACHE" align="center" ></el-table-column> -->
                                                        <el-table-column prop="chantier" label="PROJET/CHANTIER" align="center" ></el-table-column>
                                                        <el-table-column prop="dateDbtFin" label="PERIODE"></el-table-column>
                                                        <el-table-column prop="dureePresence" label="PRESENCE(hr)" align="center" ></el-table-column>
                                                       <el-table-column prop="dureePresenceHeureSupp" label="PRESENCE HEURE SUPP(hr)" align="center" ></el-table-column>
                                                        <el-table-column prop="montantContrat" label="MONTANT/(hr)" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag type="info">
                                                                    {{ scope.row.montantContrat }}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column prop="montantContratHeuSupp" label="MONTANT HEURE SUPP/(hr)" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag type="info">
                                                                    {{ scope.row.montantContratHeuSupp }}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column prop="montantTotal" label="MONTANT TOTAL" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag>
                                                                    {{ new Intl.NumberFormat().format(scope.row.montantTotal) }}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>

                                                        <!--<el-table-column prop="mntRestant" label="MONTANT A PAYE" align="center" >-->
                                                            <!--<template slot-scope="scope">-->
                                                                <!--<el-tag type="success">-->
                                                                    <!--{{ new Intl.NumberFormat().format(scope.row.mntRestant) }}-->
                                                                <!--</el-tag>-->
                                                           <!--</template>-->
                                                        <!--</el-table-column>-->

                                                        <el-table-column prop="mntVerse" label="MONTANT PAYE" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag type="success">
                                                                    {{ new Intl.NumberFormat().format(scope.row.mntVerse) }}
                                                                </el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="mntRestant" label="MONTANT RESTANT" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag type="warning">
                                                                    {{ new Intl.NumberFormat().format(scope.row.mntRestant) }}
                                                                </el-tag>

                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column label="ACTION">
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn :disabled="scope.row.montantTotalFormat == 0" slot="activator" fab small  color="primary" @click.native.prevent="showDialogPaiement(scope.row)" dark>
                                                                        <v-icon center>attach_money</v-icon>
                                                                    </v-btn>
                                                                    Notifier un paiement
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="EditoOuvrier(scope.row)" fab dark small color="orange">
                                                                        <v-icon dark>edit</v-icon>
                                                                    </v-btn>
                                                                    Edit pointage...
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </el-tab-pane>

                                <el-tab-pane label="Paiements" >
                                    <v-layout row>

                                        <!--Historique des paiements-->
                                        <v-flex xs12 class="elevation-3  pt-3 pl-3 pr-3 pb-3">
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <h4 mt-2>HISTORIQUE DES PAIEMENTS</h4>
                                                    <v-divider class="mb-3"></v-divider>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <data-tables :data="listePaiements" style="width:99%;">
                                                        <el-table-column prop="idContrat" label="ID-CONTRAT" align="center" ></el-table-column>
                                                        <el-table-column prop="libelleFact" label="FACTURE" align="center" ></el-table-column>
                                                        <el-table-column prop="refFact" label="REFERENCE" align="center" >
                                                        </el-table-column>
                                                        <el-table-column prop="libelleTrx" label="TRAVAUX" align="center" ></el-table-column>
                                                        <el-table-column prop="mnt" label="MONTANT" align="center" >
                                                            <template slot-scope="scope">
                                                                <el-tag type="info">
                                                                    {{ scope.row.mnt }}
                                                                </el-tag>
                                                            </template>

                                                        </el-table-column>
                                                        <el-table-column prop="auteur" label="AUTEUR" align="center" ></el-table-column>
                                                        <el-table-column prop="datePaiement" label="DATE DE PAIEMENT" align="center" ></el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </el-tab-pane>
                            </el-tabs>
                        </v-flex>
                    </v-layout>
                    <br/>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogValideFacture" persistent max-width="98%">
            <v-card>
                <v-card-title class="headline">
                Confirmation de paiement
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mb-5" >
                    <el-alert
                            :title="'Voulez-vous effectuer un paiement '"                                
                            type="warning"
                            center
                            :closable="false"
                            show-icon>
                    </el-alert>

                    <!-- Listes des besoins selectionnes -->
                    <el-table
                            border
                            highlight-current-row
                            show-summary
                            :header-row-style="headerRowStyle"
                            :data="listeFactureSelect"
                            style="width: 100%; margin-top:30px">
                        <el-table-column
                                align="center"
                                prop="ouvrier"
                                label="Ouvrier">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="projet"
                                label="Projet">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="chantier"
                                label="Chantier">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="mntRestant"
                                label="Montant restant">
                            <template slot-scope="scope">
                                {{ new Intl.NumberFormat().format(scope.row.mntRestant)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="montantVerse"
                                label="Montant à regler">
                            <template slot-scope="prop">
                            <!-- <div class="block"> -->
                                <el-input-number :min="1" :max="prop.row.mntRestant" name="montantVerse" placeholder="Montant à verser" v-model="prop.row.montantVerse"  style="width:100%"></el-input-number>
                                <!-- </div> -->
                            </template>
                        </el-table-column>
                    </el-table>

                </v-card-text>
                <v-card-actions >
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn  flat @click.native="dialogValideFacture = false">Annuler</v-btn>
                <v-btn   color="green darken-1" @click="validFacture()" flat >Confirmer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



         <v-dialog v-model="dialogHeureValide" persistent max-width="98%">
            <v-card>
                <v-card-title class="headline">
                Modifier les heures de pointage
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mb-5" >
                   
                    <!-- Listes des besoins selectionnes -->
                    <el-table
                            border
                            highlight-current-row
                            show-summary
                            :header-row-style="headerRowStyle"
                            :data="listeFactureSelect"
                            style="width: 100%; margin-top:30px">
                        <el-table-column
                                align="center"
                                prop="ouvrier"
                                label="Ouvrier">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="projet"
                                label="Projet">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="chantier"
                                label="Chantier">
                        </el-table-column>
                       
                        <el-table-column
                                align="center"
                                prop="periodeHr"
                                label="Précence">
                            <template slot-scope="prop">                          
                                <el-input-number :min="1" :max="prop.row.periodeHr" name="periodeHr" placeholder="Nombre de minute" v-model="prop.row.periodeHr"  style="width:100%"></el-input-number>                                
                            </template>
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="periodeSupp"
                                label="Présence heure supp">
                            <template slot-scope="prop">
                                <el-input-number :min="1" :max="prop.row.periodeSupp" name="periodeSupp" placeholder="Nombre de minuter" v-model="prop.row.periodeSupp"  style="width:100%"></el-input-number>                                
                            </template>
                        </el-table-column>

                    </el-table>

                </v-card-text>
                <v-card-actions >
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn  flat  @click.native="closeDialogUpdateHeure()">Annuler</v-btn>
                <v-btn   color="green darken-1" @click="validUpdateHeure()" flat >Confirmer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

          <!-- MODAL PAIEMENT -->
        <!-- <v-dialog v-model="dialogValideFacture" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
            <v-card-text text-xs-center>
            <h1 align="center">Voulez-vous vraiment notifier ce paiement ?</h1>
            <p align="center">
                <v-btn @click.native="dialogValideFacture = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="red"  @click="validFacture()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
            </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
        </v-card>
        </v-dialog> -->

    </div>
</template>

<script>
    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/bar");
    require("echarts/lib/chart/pictorialBar");
    require("echarts/lib/chart/funnel");
    require("echarts/lib/chart/sankey");
    require("echarts/lib/chart/scatter");
    require("echarts/lib/component/tooltip");
    require("echarts/lib/component/title");
    import html2canvas from "html2canvas";

    import Loading from '@/components/Loading';
    export default {
        components:{ Loading },
        name: "info-ouvrier",
        props: {
            show:{
                type: Boolean
            },
            infoOuvrier: {
                type: Object
            },
        },
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                loading: false,
                onglet: "0",
                dialogInfoOuvrier: false,
                listeContratsTache: [],
                listePaiements:[],
                listeFactureSelect: [],
                montantTotalVerse:0 ,
                dialogValideFacture: false,
                dialogHeureValide: false,
                montantTotalRestant:0,
                montantTotal:0,
            }
        },
        watch:{
            show : function(newValue, oldvalue){
                this.dialogInfoOuvrier = newValue;
                if(newValue == true){
                    this.onglet = "0";
                    this.loadContratOuvrier(this.infoOuvrier.id)
                }
            }
        },
        methods:{
            handleTabClick(tab){
                switch (tab) {
                    case "0":
                        if(this.listeContratsTache.length == 0 ){
                            this.loadContratOuvrier(this.infoOuvrier.id)
                        }
                        break;
                    case "1":
                        if(this.listePaiements.length == 0 ){
                            this.loadPaiementOuvrier(this.infoOuvrier.id)
                        }
                        break;
                    case "2":
                        // if(this.listeReserves.length == 0   ){
                        //     this.loadReserves();
                        // }
                        break;

                    case "3":
                        // this.loadWorklogs(this.detailProjet.id);
                        break;

                    default:
                        break;
                }
            },
            showDialogPaiement(item) {                
                this.listeFactureSelect = [item]
                this.dialogValideFacture = true
            },
            EditoOuvrier(item) {                
                this.listeFactureSelect = [item]
                console.log('listeFactureSelect',this.listeFactureSelect)
                this.dialogHeureValide = true
            },
            validFacture(){
                this.loading = true;                
                var formdata = new FormData()                
                let item = this.listeFactureSelect[0]
                console.log('item',item)
                let url = this.domaine + 'ouvrier/'+item.idOuvrier+'/paiement/contrat/'+item.idContrat
                formdata.append("idUser", this.user.id);
                formdata.append("montant", item.montantVerse);                
                this.$http.post(url,formdata).then( response => {
                    this.dialogValideFacture = false;
                    this.loading = false;
                    this.$notify({
                        title: "Validation facture",
                        message: "L'opération s'est déroulée avec succès",
                        type: "success",
                        position: "top-center"
                    });
                }, error=>{
                    this.dialogValideFacture = false;
                    this.loading = false;
                    this.$message.error("Echec lors de la validation, verifiez votre connexion");
                })
            },
            validUpdateHeure(){
                this.loading = true;                
                var formdata = new FormData()                
                let item = this.listeFactureSelect[0]
                console.log('item',item)
                let url = this.domaine + 'ouvrier/'+item.idOuvrier+'/paiement/contrat/update_heure/'+item.idContrat
                formdata.append("idUser", this.user.id);
                formdata.append("periodeSupp", item.periodeSupp);                
                formdata.append("periodeHr", item.periodeHr);        

                this.$http.post(url,formdata).then( response => {
                    this.dialogHeureValide = false;
                    this.loadContratOuvrier(this.infoOuvrier.id)
                    this.loading = false;
                    this.$notify({
                        title: "Modification des heures",
                        message: "L'opération s'est déroulée avec succès",
                        type: "success",
                        position: "top-center"
                    });
                }, error=>{
                    this.dialogHeureValide = false;
                    this.loading = false;
                    this.$message.error("Echec lors de la validation, verifiez votre connexion");
                })
            },
            loadContratOuvrier(idOuvrier){
                this.loading = true;
                ///this.listeContratsTache.splice(0);
                let url = this.domaine + "contrat/prestataire/ouvrier/" + idOuvrier;
                this.$http.get(url).then(
                    response => {
                        this.libPrestataire = response.body.libPrestataire;
                        this.listeContratsTache = response.body.contrats;
                        this.montantTotalVerse = response.body.mntTotalVerseContrat;
                        this.montantTotalRestant = response.body.mntTotalRestantContrat;
                        this.montantTotal = response.body.mntTotalContrat;
                        this.loading = false;
                        this.statistiqueMntVerse()
                    },
                    error => {
                        this.loading = false;
                        this.$message.error("Echec lors du chargement des contrats ouvriers");
                    }
                );
            },
            loadPaiementOuvrier(idOuvrier){
                this.loading = true;
                let url = this.domaine + "contrat/prestataire/historique_paiement_ouvrier/" + idOuvrier;
                this.$http.get(url).then(
                    response => {
                        this.listePaiements = response.body.paiements;
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        this.$message.error("Echec lors du chargement des paiements ouvriers");
                    }
                );
            },
            closeDialog(){
                this.$emit('close')
            },
            closeDialogUpdateHeure() {
                this.dialogHeureValide = false
            },
            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            getSummExploitBudget(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 3) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
            //statistique etat
            statistiqueMntVerse() {

                let option = {
                    backgroundColor: '#fafafa',
                    title: {
                        text: 'STATISTIQUE MONTANT PAYE/RESTANT',
                        subtext: '',
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} : {c} ({d}%)"
                    },

                    series: [{
                        name: '',
                        type: 'pie',
                        radius: '70%',
                        center: ['50%', '50%'],


                        data: [

                            {
                                value: this.montantTotalRestant,
                                name: 'mnt restant',
                                itemStyle: {
                                    color: '#c23531'
                                }
                            },
                            {
                                value: this.montantTotalVerse,
                                name: 'mnt verse',
                                itemStyle: {
                                    color: '#22c22a'
                                }
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                };
                let geneChartStatMontVerse = echarts.init(
                    document.getElementById("statMontVerse")
                );
                geneChartStatMontVerse.setOption(option);
            },
        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/ouvrier/infoOuvrier.vue